<template>
  <div
    :class="isInline ? 'search_bar_wrapper' : 'my_search_bar_wrapper'"
    id="sticky"
  >
    <div class="my_search_bar">
      <div class="search_bar_input">
        <input
          type="text"
          placeholder="下一個目的地"
          autocomplete="off"
          id="auto_complete"
          v-model="inputKeyword"
        />
      </div>
      <div class="search_bar_btn" @click.stop="enterSearch()">
        <i class="fas fa-search desktop_search_icon"></i>
      </div>
    </div>
    <div class="search_location_wrapper" v-if="isShowLocation">
      <Location :categoryId="0" mode="search" />
    </div>
    <div class="auto_complete_wrapper">
      <ul id="auto_complete_wrapper" v-if="results.length > 0">
        <li
          v-for="(item, idx) in results"
          :key="idx"
          @click.stop="handleAutoComplete(item)"
        >
          <i
            class="fas"
            :class="
              item.searchType == 'LOCATION' ? 'fa-map-marker-alt' : 'fa-hashtag'
            "
          ></i
          >{{ item.value
          }}<span
            >共<b>{{ item.count }}</b
            >個搜尋結果</span
          >
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted, onBeforeUnmount, watch } from "vue";
import debounce from "lodash.debounce";
import Location from "@/components/Location.vue";
import ApiService from "@/services/ApiService.js";
import useEventBus from "@/config/eventBus";
import router from "@/router";
import { useStore } from "vuex";

export default {
  props: {
    isInline: {
      type: Boolean,
      required: true,
    },
    isShowLocation: {
      type: Boolean,
      required: true,
    },
  },
  components: { Location },
  setup() {
    const topHeight = ref("87px");
    const cartPopupWidth = ref(360);
    const eventBus = useEventBus();
    const store = useStore();
    const inputKeyword = ref("");
    const results = ref([]);
    const deviceMode = computed(() => store.getters["device/mode"]);

    function handleAutoComplete(_item) {
      console.log(_item);
      inputKeyword.value = _item.value;
      closeSearchBox();
      setTimeout(function () {
        if (_item.searchType.toUpperCase() == "LOCATION") {
          router.push("/search/location/" + _item.value);
        } else if (_item.searchType.toUpperCase() == "PRODUCT_CATEGORY") {
          router.push("/search/product_category/" + _item.value);
        } else if (_item.searchType.toUpperCase() == "PRODUCT_NAME") {
          router.push("/search/product_name/" + _item.value);
        } else {
          router.push("/search/other_tag/" + _item.value);
        }
      }, 200);
    }

    const getAutoComplete = async () => {
      try {
        if (inputKeyword.value.trim() != "") {
          results.value = [];
          const result = await ApiService.getAutoComplete(
            inputKeyword.value.trim()
          );

          if (result.searchboxResponse.length > 0) {
            results.value = result.searchboxResponse;
            $(".search_location_wrapper").hide();
            $(".disable_click_layer").show();
            $(".auto_complete_wrapper").slideDown();
          } else {
            openSearchBox();
          }
        } else {
          openSearchBox();
        }
      } catch (err) {
        throw new Error(`Problem filtering results: ${err}.`);
      }
    };

    const debouncedFilter = debounce(getAutoComplete, 250); // 250ms delay

    watch(() => inputKeyword.value, debouncedFilter);

    const enterSearch = () => {
      closeSearchBox();
      if (results.value.length > 0) {
        const item = results.value[0];
        if (item.searchType.toUpperCase() == "LOCATION") {
          router.push("/search/location/" + item.value);
        } else if (item.searchType.toUpperCase() == "PRODUCT_CATEGORY") {
          router.push("/search/product_category/" + item.value);
        } else if (item.searchType.toUpperCase() == "PRODUCT_NAME") {
          router.push("/search/product_name/" + item.value);
        } else {
          router.push("/search/other_tag/" + item.value);
        }
      }
    };

    const openSearchBox = () => {
      $(".search_location_wrapper").show();
      $(".disable_click_layer").show();
      $(".auto_complete_wrapper").hide();
    };

    const closeSearchBox = () => {
      $(".search_location_wrapper").hide();
      $(".auto_complete_wrapper").hide();
      $(".disable_click_layer").hide();
    };

    onMounted(() => {
      eventBus.on("closeSearchBox", () => closeSearchBox());

      $(window).on("load resize scroll", function () {
        if (deviceMode.value == "desktop") {
          if (window.innerWidth < 600) {
            cartPopupWidth.value = window.innerWidth - 40;
          }
          if (window.innerWidth <= 1024) topHeight.value = "60px";
          else topHeight.value = "87px";
          if ($("#sticky").length > 0) {
            var d = document.getElementById("sticky");
            var offset = d.offsetTop;
            if ($(this).scrollTop() > offset) {
              $(".search_bar_wrapper").css({
                position: "fixed",
                top: topHeight.value,
                left: 0,
                right: 0,
              });
            } else {
              $(".search_bar_wrapper").css({
                position: "relative",
                top: 0,
              });
            }
          }
        }
      });

      $(document).on("click", "[id^=auto_complete]", function (e) {
        e.stopPropagation();
        openSearchBox();
      });

      $(document).on({
        click: function (e) {
          if (
            $(".search_location_wrapper").is(":visible") ||
            $(".auto_complete_wrapper").is(":visible")
          ) {
            if ($(e.target).closest(".search_location_wrapper").length === 0) {
              closeSearchBox();
            }
          }
        },
      });

      const input = document.getElementById("auto_complete");
      if (input) {
        input.addEventListener("keyup", function (event) {
          if (event.keyCode === 13) {
            event.preventDefault();
            $(".search_bar_btn").trigger("click");
          }
        });
      }
    });

    onBeforeUnmount(() => {
      eventBus.off("closeSearchBox");
    });

    return {
      enterSearch,
      inputKeyword,
      handleAutoComplete,
      results,
    };
  },
};
</script>

<style scoped>
::placeholder {
  font-size: 16px;
}
</style>